import matchingImage from "../../assets/matching.webp";

function PartnerRouting() {
  return (
    <section className="overflow-hidden border-t bg-[#ffffff] section-spacing">
      <div className="section-container flex min-h-[240px] items-center">
        <div className="flex w-full flex-col items-center gap-7 sm:gap-8 md:flex-row md:items-center md:gap-10 lg:gap-12">
          {/* Image */}
          <div className="flex shrink-0 items-center justify-center md:w-[110px] lg:w-[125px]">
            <img
              src={matchingImage}
              alt=""
              className="w-[78px] object-contain sm:w-[90px] md:w-[100px] lg:w-[105px]"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Text */}
          <div className="text-center md:text-left">
            <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--hero-green)] sm:text-[12px] uppercase mb-2">
              ROUTING MATRIX
            </p>
            <p className="font-jakarta text-[17px] leading-[1.65] text-[#46565b] sm:text-[19px] lg:text-[20px]">
              Leads outside Finverse's own risk appetite are routed to a partner
              NBFC or bank through matching.
              <br className="hidden sm:block" />
              Nothing dead-ends.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PartnerRouting;